import { FC } from 'react';
import t from 'utils/translate';
import Text from 'admin/components/common/Text';
import Button from 'admin/components/common/Button';
import { Column } from 'admin/components/common/Grid';
import { Modal } from 'admin/components/common/Modal';
import { ModalManagerProvidedProps } from 'admin/components/common/ModalManager';
import { MODAL } from 'admin/constants/common';

export type KickOutInfoModalData = {
	name: string;
	email: string;
};

const KickOutInfoModal: FC<ModalManagerProvidedProps<MODAL.KICK_OUT_INFO_MODAL>> = ({ open, data, close }) => (
	<Modal open={open} destroyOnHidden width={564}>
		<Text
			size="subtitle"
			weight="semibold"
			compact
			text={t('kickOutInfoModal.title', { name: data.name })}
			style={{ marginBlockEnd: 64 }}
		/>
		<Column justifyContent="flex-start">
			<Button view="danger" onClick={close}>
				{t('kickOutInfoModal.ok')}
			</Button>
		</Column>
	</Modal>
);

export default KickOutInfoModal;
